// Environment configuration
const VPS_IP = process.env.REACT_APP_VPS_IP || '187.77.103.89';

const ENV = {
    // API URLs - will be overridden by .env files
    API_BASE: process.env.REACT_APP_API_BASE || `http://${VPS_IP}:3001/api`,

    // Image base path
    IMAGE_BASE_PATH: process.env.REACT_APP_IMAGE_BASE_PATH || '/images/gallery/products/',

    // File server URL (for serving images)
    FILE_SERVER_URL: process.env.REACT_APP_FILE_SERVER_URL || `http://${VPS_IP}:3001`,

    // Main backend URL (for ads, auth, etc.)
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || `http://${VPS_IP}:3001/api`,

    // Environment flags
    IS_DEV: process.env.NODE_ENV === 'development',
    IS_PROD: process.env.NODE_ENV === 'production',

    // VPS specific flag
    IS_VPS: process.env.REACT_APP_IS_VPS === 'true'
};

export default ENV;